import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMemo } from 'react';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { Link } from 'foundations-components/transitional/components/Link';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { SuccessIcon } from 'foundations-assets';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { BREEZE_MEETING_NOTE_TAKER_KNOWLEDGE_BASE_ARTICLE_LINK } from 'MeetingsLib/constants/knowledgeBase';
import { getCalendarSettingsUrl } from 'MeetingsLib/utils/utils';
import emptyFunction from 'react-utils/emptyFunction';
import { Spacer } from 'foundations-components/components/Spacer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const meetingNotetakerBenefitsMessageKeys = ['breeze.meetingNotetaker.benefits.autoJoins', 'breeze.meetingNotetaker.benefits.recordsAndLogs', 'breeze.meetingNotetaker.benefits.detailedSummary', 'breeze.meetingNotetaker.benefits.extractsActionItems'];
export function MeetingNotetakerInfo({
  manageSettings,
  use = 'modal',
  onCancel = emptyFunction
}) {
  const renderedHeader = useMemo(() => {
    const headerContent = /*#__PURE__*/_jsx(Text, {
      as: "h3",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "breeze.meetingNotetaker.title"
      })
    });
    if (use === 'modal') {
      return /*#__PURE__*/_jsx(DialogHeader, {
        textAlign: "left",
        children: headerContent
      });
    }
    return headerContent;
  }, [use]);
  const renderedBody = useMemo(() => {
    const illustrationSize = use === 'modal' ? '200px' : '320px';
    const gap = use === 'modal' ? '0' : '400';
    const bodyContent = /*#__PURE__*/_jsxs(Flex, {
      marginBlockStart: "400",
      alignItems: "center",
      gap: gap,
      children: [/*#__PURE__*/_jsxs(View, {
        maxInlineSize: "70%",
        children: [/*#__PURE__*/_jsx(View, {
          marginBlockEnd: "400",
          children: /*#__PURE__*/_jsx(Text, {
            textAlign: "left",
            typography: "body-100",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "breeze.meetingNotetaker.description"
            })
          })
        }), /*#__PURE__*/_jsx(View, {
          children: meetingNotetakerBenefitsMessageKeys.map(msgKey => /*#__PURE__*/_jsxs(Flex, {
            alignItems: "center",
            marginBlockEnd: "600",
            children: [/*#__PURE__*/_jsx(View, {
              marginInlineEnd: "200",
              children: /*#__PURE__*/_jsx(SuccessIcon, {
                size: "400",
                color: "icon-core-subtle"
              })
            }), /*#__PURE__*/_jsx(Text, {
              textAlign: "left",
              typography: "body-100",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: msgKey
              })
            })]
          }, msgKey))
        }), /*#__PURE__*/_jsxs(View, {
          children: [manageSettings && /*#__PURE__*/_jsx(Text, {
            textAlign: "left",
            children: /*#__PURE__*/_jsx(Link, {
              href: getCalendarSettingsUrl(),
              external: true,
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "breeze.meetingNotetaker.manageUnderCalendarInSettings"
              })
            })
          }), /*#__PURE__*/_jsx(Text, {
            textAlign: "left",
            children: /*#__PURE__*/_jsx(Link, {
              href: BREEZE_MEETING_NOTE_TAKER_KNOWLEDGE_BASE_ARTICLE_LINK,
              external: true,
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "breeze.meetingNotetaker.readKnowledgeBaseArticle"
              })
            })
          })]
        })]
      }), /*#__PURE__*/_jsx(Illustration, {
        name: "breeze-ai",
        width: illustrationSize,
        height: illustrationSize
      })]
    });
    if (use === 'modal') {
      return /*#__PURE__*/_jsx(DialogBody, {
        paddingBlockEnd: "600",
        children: bodyContent
      });
    }
    return bodyContent;
  }, [manageSettings, use]);
  const renderedFooter = useMemo(() => {
    const ctaButton = /*#__PURE__*/_jsx(Button, {
      use: "primary",
      href: getCalendarSettingsUrl(),
      external: true,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "breeze.meetingNotetaker.turnOnInSettings"
      })
    });
    if (use === 'modal') {
      return /*#__PURE__*/_jsxs(DialogFooter, {
        children: [!manageSettings && ctaButton, /*#__PURE__*/_jsx(Button, {
          use: "secondary",
          onClick: onCancel,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "breeze.meetingNotetaker.backToTask"
          })
        })]
      });
    }
    return ctaButton;
  }, [manageSettings, onCancel, use]);
  return use === 'modal' ? /*#__PURE__*/_jsxs(Modal, {
    use: "conversational",
    width: "60%",
    children: [renderedHeader, renderedBody, renderedFooter]
  }) : /*#__PURE__*/_jsx(Flex, {
    justifyContent: "center",
    alignItems: "center",
    marginBlockStart: "1000",
    children: /*#__PURE__*/_jsxs(View, {
      inlineSize: "60%",
      children: [renderedHeader, renderedBody, /*#__PURE__*/_jsx(Spacer, {
        space: "400"
      }), renderedFooter]
    })
  });
}